import { Row, Col } from "react-bootstrap";
import TeamMemberObjective from "./TeamMemberObjective";
import "./TeamMemberObjectivesList.css";

function TeamMemberObjectivesList({ objectives, language }) {
  return (
    <Col className="objectives-list">
      <Row>
        {objectives.map((element) => (
          <TeamMemberObjective
            key={element._id}
            id={element._id}
            description={element.description}
            dueDate={element.dueDate}
            startDate={element.created_at}
            weight={element.weight}
            progress={element.progress}
            status={element.status}
            checkInStatus={element.checkInStatus}
            lastCheckInProgress={element.lastCheckInProgress}
            lastCheckInStatus={element.lastCheckInStatus}
            lastCheckInDate={element.lastCheckInDate}
            language={language}
          />
        ))}
      </Row>
    </Col>
  );
}

export default TeamMemberObjectivesList;
